import { render, staticRenderFns } from "./ChatInputFile.vue?vue&type=template&id=4f2fa214&scoped=true&"
import script from "./ChatInputFile.vue?vue&type=script&lang=js&"
export * from "./ChatInputFile.vue?vue&type=script&lang=js&"
import style0 from "./ChatInputFile.vue?vue&type=style&index=0&id=4f2fa214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2fa214",
  null
  
)

export default component.exports